import { render } from "./ParticipationSlotAssessment.vue?vue&type=template&id=0b7168bc&ts=true"
import script from "./ParticipationSlotAssessment.vue?vue&type=script&lang=ts"
export * from "./ParticipationSlotAssessment.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__